import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { MarqueeBand } from "@/components/site/MarqueeBand";
import { Manifesto } from "@/components/site/Manifesto";
import { Services } from "@/components/site/Services";
import { Stats } from "@/components/site/Stats";
import { Testimonials } from "@/components/site/Testimonials";
import { EnquiryForm } from "@/components/site/EnquiryForm";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, anchors: true }}>
      <div className="bg-[#09090A] text-[#F8F8F8] font-body overflow-x-clip">
        <div className="grain-overlay" aria-hidden="true" />
        <Header />
        <main>
          <Hero />
          <MarqueeBand />
          <Manifesto />
          <Services />
          <Stats />
          <Testimonials />
          <EnquiryForm />
          <Contact />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}

export default App;
